import {FC, useMemo} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useAppSelector} from 'src/redux/hooks'
import {soSelector} from 'src/redux/slices/soSlices'

interface Props {}

export const InputQuantumSORelease: FC<Props> = () => {
  const {t} = useTranslation()
  const {orderItem} = useAppSelector(soSelector)

  const defaultValue = useMemo(() => orderItem?.so_qty_realized ?? '0', [orderItem])

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3'>
          {t('CREATE_SO.ADD_SO_MODAL.KUANTUM_SO_RILIS_LABEL')}
        </Form.Label>
      </Col>
      <Col md={8}>
        <Form.Control size='sm' defaultValue={defaultValue} disabled />
      </Col>
    </Row>
  )
}
